import { render, staticRenderFns } from "./TastingOpinion.vue?vue&type=template&id=24ae5cf3&scoped=true&"
import script from "./TastingOpinion.vue?vue&type=script&lang=js&"
export * from "./TastingOpinion.vue?vue&type=script&lang=js&"
import style0 from "./TastingOpinion.vue?vue&type=style&index=0&id=24ae5cf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ae5cf3",
  null
  
)

export default component.exports